<script lang="ts">
  import { writable } from 'svelte/store'
  import MobileDepartmentMenuItem from './MobileDepartmentMenuItem.svelte'

  import { scale, slide } from 'svelte/transition'
  import CircleXmarkWhite from './CircleXmarkWhite.svelte'

  // export let currentDepartment
  export let currentDepartmentMenu 
  $:console.log('depart menu for sanity', currentDepartmentMenu)
  $:console.log('depart menu for sanity', open)
  // export let departmentHomeItem 
  export let desktopish = false
  let open = false
  let aSubmenuIsOpen = writable(false)

  $:departmentHomeItem = document.getElementById('department-name')
  // $:console.log(departmentHomeItem.href)

  /**
   * The handler that fires when user clicks the department title. If the department menu is open,
   * a click on the link means a user intent to navigate. If it's closed, prevent default and
   * open the menu.
   * 
   * We need to sort out how we want this to close. For now, clicking the title again will close
   * the menu.
   * @param e
   */
  const handleDepartmentTitleClick = (e)=> {
    if(!open) {
      e.preventDefault()
      open = true
    }
  }
</script>
{#if document.contains(departmentHomeItem)}
{#if currentDepartmentMenu}
  <div class="department-menu" class:open class:desktopish transition:slide>
    <nav>
      <!-- {#if departmentHomeItem} -->
        <a class="mobile-department-home-item"
          href="{departmentHomeItem.href}"
          on:click={handleDepartmentTitleClick}
          >
          <span class="icon-wrap">
            <i class="fa-solid fa-square-chevron-left fa-xl"></i>
          </span>
          {departmentHomeItem.innerText}
        </a>
        {#if open}
          <button
            class="mobile-department-menu-close"
            title="Close the mobile department menu"
            on:click|stopPropagation={()=> open = false}
            in:scale={{delay: 500}}
            out:scale={{delay: 300}}
            >
            <CircleXmarkWhite class="square-3x3 block" />  
            <span class="sr-only">Close search</span>
          </button>
        {/if}
      <!-- {:else}
        <i class="fas fa-circle-notch fa-spin p-4"></i> Loading... -->
      <!-- {/if} -->

      {#if currentDepartmentMenu && open}
        <ul>
          {#each currentDepartmentMenu as _}
            <MobileDepartmentMenuItem menuItem={_} {aSubmenuIsOpen} />
          {/each}
        </ul>
      {/if}
    </nav>
  </div>
{/if}
{/if}

<style lang="scss">
  .department-menu {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 56px;
    background-color: var(--steger-silver);
    text-transform: uppercase;
    font-weight: bold;
    line-height: 1;
    transition: height 0.25s ease-in;
    overflow-y: scroll;

    > nav {
      opacity: 1!important;
    } 
    &.open {
      height: 100%;

      a.mobile-department-home-item {
          color:var(--ucBlack) ;
        span.icon-wrap {
          transform: rotate(0deg);
        }
      }
    }

    > nav {
      position: relative;
      ul{
          list-style: none;
          padding: 0;
      }
      a {
        display: block;
        color: var(--ucBlack);
        text-transform: uppercase;
        font-weight: bold;
        padding: 1.25rem 2rem;
        background-color: var(--steger-silver);
        
        &:hover, &:focus,
        &.mobile-department-home-item:hover,
        &.mobile-department-home-item:focus {
          background-color: var(--ucBlack);
          color: white;
          text-decoration: none;
        }
      }

      a.mobile-department-home-item {
        display: block;
        padding: 1rem;
        background-color: var(--steger-silver);

        span.icon-wrap {
          display: inline-block;
          transform: rotate(-90deg);
          transition: transform 0.45s ease-in-out;
        }
      }

      button.mobile-department-menu-close {
        position: absolute;
        top: 0;
        right: 0;
        height: 5.6rem;
        width: 5.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        background-color: rgba(220,220,220,0.4);

        &:hover, &:focus {
          color: var(--bearcat-black);
          background-color: var(--gelter-gold);
        }
      }
    }
    
  }
</style>